var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaricon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3684 4.10521H1.56389C2.31651 4.10521 2.93229 4.72099 2.93229 5.47361V12.3156C2.93229 13.0682 2.31651 13.684 1.56389 13.684H1.3684C0.615781 13.684 0 13.0682 0 12.3156V5.47361C0 4.72099 0.615781 4.10521 1.3684 4.10521ZM6.84201 0C7.59464 0 8.21042 0.615781 8.21042 1.3684V12.3156C8.21042 13.0682 7.59464 13.684 6.84201 13.684C6.08939 13.684 5.47361 13.0682 5.47361 12.3156V1.3684C5.47361 0.615781 6.08939 0 6.84201 0ZM12.3156 7.81945C13.0682 7.81945 13.684 8.43523 13.684 9.18785V12.3156C13.684 13.0682 13.0682 13.684 12.3156 13.684C11.563 13.684 10.9472 13.0682 10.9472 12.3156V9.18785C10.9472 8.43523 11.563 7.81945 12.3156 7.81945Z",
    fill: "#819ACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaricon);
export default __webpack_public_path__ + "static/media/baricon.bcaa45f18d5076edde2359daebffe144.svg";
export { ForwardRef as ReactComponent };